Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-inline-widget');
    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);
    var model = null;
    var hasCookie = Cookies.get('InlineAdmin');

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function update() {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("inlineAdmin", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);

        $('.js-inline-admin-trigger').on('click', function () {
            this.href += '#' + encodeURIComponent(document.location.href);
        });

        var fancyOpts = {
            type: 'iframe',
            baseClass: "inline-admin-popup",
            toolbar: false,
            smallBtn: true
        };

        $("section.admin .iframe").fancybox(fancyOpts);

        $('.inline-admin-logout').on('click', '.js-logout', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.Logout());
        });

        $('.inline-clear-cache').on('click', '.js-clear-cache', function (e) {
            e.preventDefault();

            var domain = document.location.hostname;
            var urlCache = location.protocol + '//' + domain + '/engine/clearcache?cloudflare=true';
            var urlSeoCache = location.protocol + '//' + domain + '/engine/clearseocache';
            var _clearAkamaiCache = function (options) {
                var _actualPurge = function (options) {
                    $.ajax({
                        type: "POST",
                        contentType: "application/json; charset=utf-8",
                        url: LhApp.Context.InLineAdminEndpoint + '/vendd/api/Akamai/Purge',
                        xhrFields: { withCredentials: true },
                        data: JSON.stringify({
                            "objects": [location.protocol + '//' + domain + '/'],
                            "purgeby": 1,
                            "method": 1,
                            "enviroment": 1
                        }),
                        success: function (response) {
                            if (!!response.data && !!response.data.Message && typeof response.data.Message === 'string') {
                                options.success(response.data.Message);
                            } else {
                                options.success('ok');
                            }
                        },
                        error: function (response) {
                            console.error(response);
                            options.error(response);
                        },
                    });
                }
                $.ajax({
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    url: LhApp.Context.InLineAdminEndpoint + '/vendd/api/Akamai/Configuration',
                    xhrFields: { withCredentials: true },
                    success: function (response) {
                        if (!!!response)
                        {
                            console.error(response);
                            error(response);
                            return;
                        }
                        if (!response.success)
                        {
                            console.error(response);
                            options.error(response);
                            return;
                        }
                        if (!response.data.IsEnabled)
                        {
                            options.success(options.data);
                            return;
                        }
                        _actualPurge({
                            data: response,
                            success: options.success,
                            error: options.error
                        });
                    },
                    error: function (response) {
                        console.error(response);
                        options.error();
                    }
                });
            };
            var _clearCache = function () {

                $.post(urlSeoCache, function (data) {
                    $.post(urlCache, function (data) {
                        _clearAkamaiCache({
                            data: data,
                            success: function(data) {
                                var message = 'Cache cleared';
                                if (typeof data === 'string') {
                                    message = data;
                                }
                                alert(message);
                    location.reload();
                            },
                            error: function(data) {
                                var message = 'An error occured';
                                if (typeof data === 'string') {
                                    message = data;
                                }
                                if (typeof data === 'object') {
                                    message = JSON.stringify(data);
                                }
                                alert(message);
                            }
                        });
                    });
                });

            };

            $.ajax({
                type: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: LhApp.Context.InLineAdminEndpoint + '/vendd/api/InlineAdmin/NginXPurge',
                data: JSON.stringify({ "uri": location.protocol + '//' + domain + '/*' }),
                xhrFields: { withCredentials: true },
                success: function (response) {

                    _clearCache();

                },
                error: function (response) {

                    _clearCache();
                    console.error(response);

                }
            });

        });

        $('.inline-admin-newguest').on('click', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.InlineAdmin.Messages.CheckForInlineAdmin(true));

        });
        $('.inline-admin-clearinterfaceuser').on('click', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserSelect.Messages.ClearInterfaceUser());

        });

        $('section.admin .shippingCountry').on('click', function (e) {
            e.preventDefault();
            window.location.href = LhApp.Function.Url.setParameterValue("country", $(this).data("country"));
        });         

        $('.header-spacer').addClass('has-inline-admin');
        $('.header-region').addClass('has-inline-admin');

    };

    wrapper.newGuid = function newGuid() {
        return ([1e7] + [-1e3] + [-4e3] + [-8e3] + [-1e11]).replace(/[018]/g, (parseInt('$2') ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt('$2') / 4).toString(16));
    };

    Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.ClearInterfaceUserSuccess, wrapper, function (envelope) {
        location.reload();
    });

    if (hasCookie) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.InlineAdmin.Messages.CheckForInlineAdmin());

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CheckForInlineAdminSuccess, wrapper, function (envelope) {

            model = envelope.message.data.model.data;
            if (model.CallCenter.InterfaceUserIsNewGuest)
                location.reload();

            wrapper.update();
        });

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CheckForInlineAdminFailure, wrapper, function (envelope) {
            Cookies.set('InlineAdmin', '', { expires: 0, samesite: 'Lax' });
        });

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminSuccess, wrapper, function (envelope) {
            model = envelope.message.data.model;
            var redirectUrl = envelope.message.data.redirectUrl;

            hasCookie = Cookies.get('InlineAdmin');

            if (!hasCookie) {
                Cookies.set('InlineAdmin', wrapper.newGuid(), { expires: 1, samesite: 'Lax' });
            }

        });
    }

});
